import moment from "moment";
import React from "react";
import { Button } from "semantic-ui-react";
import CardRowSegment from "../../components/CardRowSegment/CardRowSegment";
import FormattedAddress from "components/Atoms/FormattedAddress";

interface Props {
  paymentMethod: server.dto.ClientPaymentMethod
  onChangePaymentMethod: () => void
}

const CurrentPaymentMethodContent = ({ paymentMethod, onChangePaymentMethod }: Props) => {
  return <div className="flex">
    <div className="grow1 margin-right-huge">
      <div>
        {paymentMethod.type === "invoice" && <>
          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{RESX.Payment.PaymentMethod}</CardRowSegment.Header>
            {RESX.Invoice.xInvoice}
          </CardRowSegment>
        </>}

        {paymentMethod.type === "card" && <>
          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{paymentMethod.brand}</CardRowSegment.Header>
            •••• {paymentMethod.last4}
          </CardRowSegment>

          <CardRowSegment>
            <CardRowSegment.Header>{RESX.Payment.Expires}</CardRowSegment.Header>
            {moment.monthsShort(paymentMethod.expMonth - 1)} {paymentMethod.expYear}
          </CardRowSegment>
        </>}

        {paymentMethod.type === "sepaDebit" && <>
          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{RESX.Payment.PaymentMethod}</CardRowSegment.Header>
            {RESX.PaymentMethods.SepaDebit}
          </CardRowSegment>

          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{RESX.Company.IbanNumber}</CardRowSegment.Header>
            •••• {paymentMethod.last4}
          </CardRowSegment>

          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{RESX.GeneralLabels.Details}</CardRowSegment.Header>
            <div className="margin-bottom-small">{paymentMethod.billingDetails.name}</div>
            <FormattedAddress address={paymentMethod.billingDetails.address} />
          </CardRowSegment>

          <CardRowSegment className="margin-bottom-small">
            <CardRowSegment.Header>{RESX.GeneralLabels.Email}</CardRowSegment.Header>
            {paymentMethod.billingDetails.email}
          </CardRowSegment>
        </>}
      </div>

    </div>
    <div style={{ flex: "0 0 40%" }} className="flex-column">
      <div>
        <Button className="green" fluid onClick={onChangePaymentMethod}>
          {RESX.Payment.ChangePaymentMethod}
        </Button>
      </div>
    </div>
  </div>;
};

export default CurrentPaymentMethodContent;
